import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField, Button } from "@mui/material";

export default function DialogReprovarAprovacao({
  aberto,
  motivo,
  onChangeMotivo,
  onCancelar,
  onConfirmar,
  processando,
  titulo,
  contentText = "Informe o motivo da reprovação:",
  rows = 6,
  maxLength, // mantido por compatibilidade: o texto agora é livre
  maxWidthFullWidth = true,
  labelConfirmar = "Reprovar",
  corConfirmar = "#c62828",
}) {
  return (
    <Dialog open={aberto} onClose={onCancelar} {...(maxWidthFullWidth ? { maxWidth: "md", fullWidth: true } : {})}>
      <DialogTitle sx={{ backgroundColor: "var(--ig-f-1e1e1e)", color: "var(--ig-t-ffffff)" }}>{titulo}</DialogTitle>
      <DialogContent sx={{ backgroundColor: "var(--ig-f-1e1e1e)", pt: "20px !important", overflowX: "hidden" }}>
        <DialogContentText sx={{ color: "var(--ig-t-aaaaaa)", mb: 2 }}>{contentText}</DialogContentText>
        <TextField
          autoFocus
          fullWidth
          multiline
          // Texto livre: campo maior, que cresce conforme a digitação.
          minRows={Math.max(rows, 8)}
          maxRows={20}
          label="Motivo"
          value={motivo}
          onChange={(e) => onChangeMotivo(e.target.value)}
          helperText={`${motivo.length} caracteres`}
          slotProps={{
            htmlInput: { style: { color: "var(--ig-t-ffffff)" } },
            inputLabel: { sx: { color: "var(--ig-t-888888)", "&.Mui-focused": { color: "var(--ig-t-64b5f6)" } } },
          }}
          sx={{
            "& .MuiOutlinedInput-root": { "& fieldset": { borderColor: "var(--ig-b-444444)" } },
            "& .MuiFormHelperText-root": { color: "var(--ig-t-888888)" },
          }}
        />
      </DialogContent>
      <DialogActions sx={{ backgroundColor: "var(--ig-f-1e1e1e)", pb: 2, pr: 2 }}>
        <Button onClick={onCancelar} sx={{ color: "var(--ig-t-888888)" }}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={onConfirmar}
          disabled={!motivo.trim() || processando}
          sx={{ backgroundColor: corConfirmar, textTransform: "none" }}
        >
          {labelConfirmar}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
